function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#2BCDC0",
  d: "M11.078671,0.17500318 C7.58555548,0.169966579 4.36471342,2.06052803 2.66623508,5.11291284 C0.967756737,8.16529766 1.05907785,11.8988893 2.90475438,14.8645865 L0.0786710456,20.8000032 L6.01317105,17.9739198 C9.48383418,20.131776 13.9387868,19.8626298 17.1244205,17.3026331 C20.3100543,14.7426364 21.5317166,10.4500167 20.1714102,6.59626371 C18.8111037,2.74251069 15.1654542,0.167965756 11.078671,0.17500318 Z"
}), React.createElement("g", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  transform: "translate(4.891 6.82)"
}, React.createElement("path", {
  d: "M2.06066667.229166667L10.3106667.229166667M.685666667 2.97916667L11.6856667 2.97916667M2.06066667 5.72916667L10.3106667 5.72916667"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    className: "icon",
    style: {
      "height": "1em",
      "width": "1em"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/text-message-large.7f5b1226.svg";
export { SvgComponent as ReactComponent };